import axios from "axios";

export function loadLocations(action) {
  const search = action.search;
  const metaData = {
    withCredentials: true,
  };

  return new Promise((resolve) => {
    axios
      .get(
        `${process.env.REACT_APP_BACKEND}/location_search/${search}`,
        metaData
      )
      .then((response) => {
        resolve({"ok": response.status === 200, ...response.data});
      })
      .catch((e) => {
        resolve(e);
      });
  });
}
